import { render, staticRenderFns } from "./ProfileChangeEmail.vue?vue&type=template&id=2bab06d2&scoped=true"
import script from "./ProfileChangeEmail.vue?vue&type=script&lang=js"
export * from "./ProfileChangeEmail.vue?vue&type=script&lang=js"
import style0 from "./ProfileChangeEmail.vue?vue&type=style&index=0&id=2bab06d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab06d2",
  null
  
)

export default component.exports